export class HHSGSharedNotificationDetails {
    notificationId : number;
    name : string;
    message : string;
    isRead : boolean;
    userId : number;
    userName : string;
    isHighPriority : boolean;
    notificationCreatedDate :Date;
    isSelected : boolean=false;
    notificationFrom : string;
  }